<template>
    <div class="refund">
        <div class="d-center-start mb-3 w-50">
            <left-text leftText="验证手机号"/> {{ userLoginMessage.mobile | formatPhone }}
        </div>
        <div class="d-center-start mb-4 w-100">
            <left-text leftText="验证码"/>
            <send-phone-code :phoneNumber="userLoginMessage.mobile" template="SMS_269200254" class="w-100" url="/pc/User/GetSafeCode"
                            @showError="msg => this._alert(msg,null,'error')"
                            @getCode="code => this.mayFormdata.sms_code = code"/>
        </div>
        <left-text-select class="w-100 mb-3" leftText="退款方式" :options="$GVAR.payTypeWay " v-model="payTypeWayId" :Height="true"/>
        <left-text-number  v-model="mayFormdata.refund" leftText="退款金额" tip="请填写退款金额" :precision="2" :min="0" :max="approve" :step="0.01"  v-if="payTypeWayId=='2'"/>
        <div class="price mb-3 w-100">最高可退 <span class="text-danger">&yen;{{approve}}</span></div>
        <el-button slot="footer" type="primary" @click="mayclick" class="button w-60 mt-4">确认退款</el-button>
    </div>
</template>

<script>
  import { data } from 'jquery';
import { mapActions,mapState } from 'vuex'
    export default {
        name: "Refund",
        props:{
            logon:{default: true},
            OrderDetail:{
                type:Object,
                default: {}
            },
        },
        data() {
            return {
                approve:0,                                //可填写退款最大金额
                payTypeWayId:"1",                         //退款方式
                mayFormdata:{
                    tid:this.OrderDetail.tid,             //交易ID
                    refund:'',                            //退款金额
                    sms_code:'',                          //验证码
                },
            }
        },
        computed: {
            ...mapState(['userLoginMessage']),
        },
        mounted() {
            this.balance();
            // this.Withdrawal({
            //     data:{},
            //     successFun:(loading)=>{
            //         this.$emit('countdownPromise',{loading});
            //     }
            // })
        },
        // components: {CardInfoComponent},
        methods: {
            ...mapActions(['Withdrawal']),
            /*表单验证*/
            validateForm () {
                let mayFormdata=this.mayFormdata;
                if (!mayFormdata.sms_code) return { code: false, msg: '请填写验证码' }
                if (this.payTypeWayId=="2"&&!mayFormdata.refund) return { code: false, msg: '请填写退款金额' }
                return { code: true, msg: '表单验证通过' }
            },
            //确认退款
                 mayclick(){
                let tist=this;
                let result = this.validateForm();
                if (result.code) {
                    //如果位全额则默认最大金额
                    if(this.payTypeWayId=="1"){
                      this.mayFormdata.refund=this.approve
                    }
                    this.Withdrawal({
                        data:this.mayFormdata,
                        successFun(loading){
                            tist.$emit('countdownPromise',{loading});
                          }
                    })
                    this.$emit('close');
                }else this._alert(result.msg,null,'error');
            },
            //支付宝二维码支付
            async alipayH5(data){
                let resData = await this.$axios.post('/pc/AliPay/Native',data);
                if(resData.code=="00000"){
                    this.qianHtml=resData.data;
                }
            },
            //可退款金额
            balance(){
                let item = this.OrderDetail;
                this.approve=(item.total_fee-Math.abs(item.refund_fee))/100
            },
        }
    }
</script>
<style scoped>
.price{
  font-size: 12px;
  text-align: right;
}
.refund{
    text-align: center  ;
}
</style>
